<template>
    <div>
        <app-page-header title="News" subtitle="Our latest team news." class="news-page-header" />
        <app-content-loader v-if="loading" />
        <div class="news-listing">
            <b-container>
                <b-row class="align-items-end">
                    <b-col md="12" lg="8" v-for="insight in recentInsights.slice(0,1)" :key="insight.id">
                        <router-link :to="{ name: 'NewsDetail', params: { id: insight.id }}">
                            <news-card :insight="insight" detail />
                        </router-link>
                    </b-col>
                    <b-col lg="4">
                        <b-row>
                            <b-col md="6" lg="12" v-for="insight in recentInsights.slice(1,3)" :key="insight.id" class="mt-4">
                                <router-link :to="{ name: 'NewsDetail', params: { id: insight.id }}">
                                    <news-card :insight="insight" compact />
                                </router-link>
                            </b-col>
                        </b-row>
                    </b-col>
                </b-row>
                <div v-if="insights" class="mt-5 mb-5">
                    <h2>Latest Articles</h2>
                    <b-row>
                        <b-col md="6" lg="4" class="mb-4" v-for="insight in insights" :key="insight.id">
                            <router-link :to="{ name: 'NewsDetail', params: { id: insight.id }}">
                                <news-card :insight="insight" />
                            </router-link>
                        </b-col>
                    </b-row>
                    <div class="see-more-btn text-center mb-5">
                        <app-content-loader v-if="loading" title="News" />
                        <a v-if="showMoreEnabled" @click="updateOffset">See more</a>
                    </div>
                </div>
            </b-container>
        </div>
    </div>
</template>

<script>
import listInsights from '@/graphql/ListInsights.gql';
import AppPageHeader from '@/components/global/AppPageHeader';
import NewsCard from '@/components/news/NewsCard';
import AppContentLoader from '@/components/global/AppContentLoader';

const PER_PAGE = 12;

export default {
    name: 'news',

    components: {
        AppPageHeader,
        NewsCard,
        AppContentLoader,
    },

    apollo: {
        insights: {
            query: listInsights,
            variables() {
                return {
                    limit: PER_PAGE,
                    offset: 3,
                };
            },
            loadingKey: 'loading',
            watchQuery: { fetchPolicy: 'network-only' },
            fetchPolicy: 'network-only',
        },

        totalInsights: listInsights,
        recentInsights: listInsights,
    },

    data() {
        return {
            insights: '',
            recentInsights: '',
            loading: 0,
            offset: 3,
            page: 0,
        };
    },
    computed: {
        showMoreEnabled() {
            return this.totalInsights && this.totalInsights.aggregate.count - 3 > this.insights.length;
        },
    },
    methods: {
        updateOffset() {
            this.page++;
            this.offset = this.page * PER_PAGE + 3;
            this.fetchData();
        },

        async fetchData() {
            await this.$apollo.queries.insights.fetchMore({
                variables: {
                    limit: PER_PAGE,
                    offset: this.offset,
                },
                updateQuery: (previousResult, { fetchMoreResult }) => {
                    if (!fetchMoreResult) {
                        return previousResult;
                    }
                    return Object.assign({}, previousResult, {
                        insights: [...previousResult.insights, ...fetchMoreResult.insights],
                    });
                },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.news-page-header {
    &.app-header.jumbotron {
        @include media-breakpoint-up(lg) {
            padding-bottom: 88px;
        }
    }
}
a {
    cursor: pointer;
    text-decoration: none;
    color: inherit;

    &:hover {
        text-decoration: none;
        color: inherit;
    }
}
.news-listing {
    padding-top: 50px;
    @include media-breakpoint-up(lg) {
        transform: translate(0, -70px);
        padding-top: 0;
    }
}
h2 {
    font-size: 28px;
    font-weight: 700;
    line-height: 1.5;
    margin-bottom: 30px;
}
</style>
